import { DefaultError, useQuery } from '@tanstack/react-query';
import { THEME_TYPE, useStateStorage } from 'store/state';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ITheme } from './types';

export const useGetTheme = (enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  const { setTheme, setThemeType, themeType } = useStateStorage();
  return useQuery<ITheme, DefaultError>({
    queryKey: ['current-theme'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Theme/GetCurrentTheme`,
      });

      const theme = await responseHandler<ITheme>(response, {
        groupName: `useGetTheme`,
        onNotFound: () => {},
      });

      // if (theme.primary !== null && theme.darkPrimary === null) {
      //   localStorage.setItem('theme-mode', '1');
      //   setThemeType(THEME_TYPE.light);
      // }
      // if (theme.primary === null && theme.darkPrimary !== null) {
      //   localStorage.setItem('theme-mode', '2');
      //   setThemeType(THEME_TYPE.dark);
      // }

      if (themeType === null) {
        const mode = theme.defaultThemeMode ?? THEME_TYPE.light;
        localStorage.setItem('theme-mode', `${mode}`);
        setThemeType(mode);
      }

      setTheme(theme);

      return theme;
    },
    enabled,
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
export const useGetThemes = (enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ITheme[], DefaultError>({
    queryKey: ['current-themes'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Theme/GetAvailableThemes`,
      });

      return responseHandler(response, {
        groupName: `useGetThemse`,
        onNotFound: () => {},
      });
    },
    enabled,
  });
};
